import React from "react"

const LoadingIndicator = () => {
  return (
    <div
      className="container d-flex justify-content-center align-items-center"
      style={{ minHeight: "320px" }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )
}

export default LoadingIndicator

export const LoadingSpinner = ({ small }: { small?: boolean }) => {
  return (
    <div
      className="spinner-border text-primary"
      role="status"
      style={
        small
          ? {
              height: 16,
              width: 16,
            }
          : {}
      }
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}
